const dialogSteps = {
    discardUnfinishedWork: 0,
    handleUnallocatedTime: 1,
    discardTime: 2,
    caseDescriptionWarning: 3,
    caseEmployeeWarning: 4,
    caseFilesTreeChangeWarning: 5,
}

export default dialogSteps